"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.focuseable = exports.swipeable = void 0;
var swipeable_1 = require("./swipeable");
__createBinding(exports, swipeable_1, "default", "swipeable");
var focuseable_1 = require("./focuseable");
__createBinding(exports, focuseable_1, "default", "focuseable");
//# sourceMappingURL=index.js.map